import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSignalCellular4Bar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.42494 21.9999C3.97494 21.9999 3.66227 21.7956 3.48694 21.3869C3.31227 20.9789 3.38327 20.6166 3.69994 20.2999L20.2999 3.69994C20.6166 3.38327 20.9793 3.31227 21.3879 3.48694C21.7959 3.66227 21.9999 3.97494 21.9999 4.42494V20.9999C21.9999 21.2833 21.9039 21.5206 21.7119 21.7119C21.5206 21.9039 21.2833 21.9999 20.9999 21.9999H4.42494Z",
		fill: "currentColor"
	})
});
export default SvgSignalCellular4Bar;
